export enum INQUIRY_ACTION {
	BUY = 'buy',
	SELL = 'sell',
}
